import { render, staticRenderFns } from "./RegimenView.vue?vue&type=template&id=3184f3c5"
import script from "./RegimenView.vue?vue&type=script&lang=js"
export * from "./RegimenView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports